module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.0062c346.ttf";